// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContributorData } from '@lfx/key-projects/key-projects.model';
import {
  OverlappingAvatarsComponent,
  AvatarItem,
} from '@lfx/shared/components/overlapping-avatars';

@Component({
  selector: 'lfx-contributors-column',
  imports: [CommonModule, OverlappingAvatarsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="contributors-container">
      <lfx-overlapping-avatars
        [avatars]="avatarItems()"
        [maxVisible]="5"
        [size]="'sm'"
        [expandOnHover]="false"
      />
      <span class="contributor-total lf-body-base">{{ contributors().count }}</span>
    </div>
  `,
  styleUrls: ['./contributors-column.component.scss'],
})
export class ContributorsColumnComponent {
  readonly contributors = input.required<ContributorData>();

  // Transform ContributorData.avatars to AvatarItem[]
  protected readonly avatarItems = computed<AvatarItem[]>(() =>
    this.contributors().avatars.map(contributor => ({
      id: contributor.id,
      name: contributor.name,
      imageUrl: contributor.avatarUrl,
    }))
  );
}
